import { useRef, useEffect, useState } from 'react';
import { Group, Circle, Transformer } from 'react-konva';
import { Html } from 'react-konva-utils';
import { styled } from '@mui/material/styles';
import FilledInput from '@mui/material/FilledInput';
import InputAdornment from '@mui/material/InputAdornment';

const ContextMenu = styled('div')`
  display: none;
  position: absolute;
  width: 220px;
  background-color: white;
  box-shadow: 0 0 5px grey;
  border-radius: 3px;
`;

const ContextMenuButton = styled('button')`
  width: 100%;
  background-color: white;
  border: none;
  margin: 0;
  padding: 10px;
  :hover {
    background-color: lightgray;
  }
`;

export default function CircleWithTransformer(props) {
  const [showTransformer, setShowTransformer] = useState(false);
  const [selected, setSelected] = useState(false);
  const stageRef = props.stageRef;

  const circleRef = useRef(null);
  const transformerRef = useRef(null);

  useEffect(() => {
    document.addEventListener('clearSelections', onClearSelections);

    return () => {
      document.removeEventListener('clearSelections', onClearSelections);
    };
  }, []);

  useEffect(() => {
    save();
  }, []);

  const onClearSelections = (e) => {
    const target = e.detail.target;
    const hasParent = Boolean(target.parent);
    let hasNodes = false;
    if (hasParent) {
      hasNodes = Boolean(target.parent._nodes);
    }

    if (target === circleRef.current) {
      // setSelected(true);
      // setShowTransformer(true);
      // props.setSelected(circleRef);
      //skip
    } else if (hasParent && hasNodes && target.parent._nodes[0] === circleRef.current) {
      //skip
    } else {
      setSelected(false);
      setShowTransformer(false);
    }
  };

  useEffect(() => {
    if (showTransformer) {
      transformerRef.current.nodes([circleRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [showTransformer]);

  const onSelect = (e) => {
    if (e.evt.button === 0 || e.evt.touches) {
      setShowTransformer(true);
      setSelected(true);
      props.setSelected(circleRef);
    }
  };

  const onTap = (e) => {
    if (e.evt.touches.length > 1) {
      //onContextMenu(e);
    } else {
      onSelect(e);
    }
  };

  const onDragEnd = (e) => {
    save();
  };

  const onTransformEnd = (e) => {
    save();
  };

  const save = () => {
    if (props.setSaveData) {
      return props.setSaveData({
        [props.id]: {
          id: props.id,
          key: props.id,
          type: 'CircleWithTransformer',
          x: circleRef.current.attrs.x,
          y: circleRef.current.attrs.y,
          radius: circleRef.current.attrs.radius
        }
      });
    }
  };

  return (
    <>
      <Circle
        {...props}
        onClick={onSelect}
        ref={circleRef}
        draggable={showTransformer}
        strokeScaleEnabled={false}
        // onContextMenu={onContextMenu}
        onTouchStart={onTap}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
        stroke={'#ED5521'}
        fill={'green'}
        strokeWidth={0.2}
        // shadowColor={'#ED5521'}
        // shadowBlur={5}
        strokeEnabled={selected}
        shadowEnabled={selected}
        opacity={0.75}
      />
      {showTransformer && <Transformer ref={transformerRef} />}
      {/* <Html>
        <ContextMenu
          id="menu"
          ref={menuRef}
        >
          {selected && <ContextMenuButton onClick={() => props.delete(props.id)}>Delete</ContextMenuButton>}
        </ContextMenu>
      </Html> */}
    </>
  );
}
